import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null); // null = checking, false = not logged in
    const [error, setError] = useState("");

    useEffect(() => {
        const token = localStorage.getItem("sf_token");
        if (!token) {
            setUser(false);
            return;
        }
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => {
                localStorage.removeItem("sf_token");
                setUser(false);
            });
    }, []);

    const login = async (email, password) => {
        try {
            setError("");
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem("sf_token", data.token);
            setUser(data.user);
            return data.user;
        } catch (e) {
            const msg = formatApiError(e);
            setError(msg);
            throw new Error(msg);
        }
    };

    const register = async (name, email, password) => {
        try {
            setError("");
            const { data } = await api.post("/auth/register", { name, email, password });
            localStorage.setItem("sf_token", data.token);
            setUser(data.user);
            return data.user;
        } catch (e) {
            const msg = formatApiError(e);
            setError(msg);
            throw new Error(msg);
        }
    };

    const logout = () => {
        localStorage.removeItem("sf_token");
        setUser(false);
    };

    const refreshMe = async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            return data;
        } catch {
            return null;
        }
    };

    return (
        <AuthContext.Provider
            value={{ user, error, login, register, logout, refreshMe, setUser }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
